import styled from 'styled-components'

const CheckboxStyled = styled.input`
  border: 1px solid ${(props) => props.theme.borderGrey};
  height: 5rem;
  padding-left: 2rem;
  padding-right: 2rem;
  border-radius: 0.5rem;
  display: block;
  width: 100%;
  background-color: transparent;

  &:disabled + label,
  &[disabled] + label,
  &:checked:disabled + label,
  &:checked[disabled] + label {
    color: #a5a6a8;
    cursor: not-allowed;

    & * {
      color: #a5a6a8;
    }

    &::before {
      background-color: #f3f3f3;
      border-color: #a5a6a8;
    }

    &::after {
      background: #a5a6a8;
      box-shadow: 2px 0 0 #a5a6a8, 4px 0 0 #a5a6a8, 4px -2px 0 #a5a6a8,
        4px -4px 0 #a5a6a8, 4px -6px 0 #a5a6a8, 4px -8px 0 #a5a6a8;
    }
  }
`

export default CheckboxStyled
